// extracted by mini-css-extract-plugin
export var btn = "D_mB q_rr q_q6 d_bz d_bP d_bD d_dw";
export var full = "D_t6 d_w d_H";
export var hoverStyle = "D_mF";
export var zoom = "D_mG";